<template>
  <div class="ActiveUserRow d-flex align-items-center mt-4">
    <span class="ActiveUserRow__Label mr-3">
      {{ user.name }}
    </span>
    <span class="ActiveUserRow__Email flex-grow-1 mr-3">
      {{ user.email }}
    </span>
    <span class="ActiveUserRow__Role mr-3">
      <SimpleSelect :disabled="processing" v-model="role" :options="options" />
    </span>
    
    <SvgIcon icon="trash-alt-regular" @click.native="handleRemoveRole" tooltip="" />
  </div>
</template>

<script>

import SvgIcon from '@/components/common/SvgIcon'
import SimpleSelect from '@/components/form/SimpleSelect'

/**
 * This component is used in the UserPanel component
 */
export default {
  name: 'ActiveUserRow',
  components: { SvgIcon, SimpleSelect },
  props: {
    user: {
      type: Object,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      /**
       * Used to indicate a role change is still being processed.
       */
      processing: false,

      options: [{ 
        label: 'gast',
        value: 'guest'
      }, {
        label: 'medewerker',
        value: 'editor'
      }, {
        label: 'beheerder',
        value: 'admin'
      }]
    }
  },
  computed: {
    /**
     * Simplify data access
     */
    meta() {
      return this.user.app_metadata.evmaps
    },
    isSuperUser() {
      return this.meta.superuser
    },
    role: {
      get() {
        let selected = 'guest' 
        // Go over the possible roles
        this.meta.roles.forEach(role => {
          if (role.municipalities.includes(this.code)) {
            selected = role.role
          }
        })
        return selected
      },
      set(role) {
        this.processing = true

        this.$emit('roleChange', {
          user: this.user,
          role
        })
      }
    }
  },
  watch: {
    /**
     * When we get new user details it means the user has been updated
     */
    user: {
      handler() {
        this.processing = false
      },
      deep: true
    }
  },
  created() {
    console.log("row", this.user)
  },
  methods: {
    /**
     * Simply set the role to null to remove a role
     */
    handleRemoveRole() {
      console.log("remove role")
      if (this.processing) return
      
      this.processing = true

      this.$emit('roleChange', {
        user: this.user,
        role: null
      })
    }
  }
}
</script>

<style lang="scss">
.ActiveUserRow {
  &__Label {
    width: 175px;
  }
  &__Role {
    width: 150px;
  }
  .SvgIcon {
    cursor: pointer;

    &:hover {
      color: rgb(214, 82, 0);
    }
  }
}
</style>